import { render, staticRenderFns } from "./IconPersonal.vue?vue&type=template&id=61ef3ca1&"
import script from "./IconPersonal.vue?vue&type=script&lang=js&"
export * from "./IconPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports